// Single project-centric flow: every module is a tab of /projects/:id.
// Workflow stages and the sidebar both resolve to one of these tabs.
export const STAGE_TAB = {
  intake: "intake",
  design: "design",
  validation: "validation",
  drawings: "drawings",
  client_docs: "documents",
  bom: "bom",
  scm: "scm",
  client_approval: "documents",
  released: "overview",
  // legacy stage keys (pre-June-2026 flow)
  optimization: "design",
  review: "validation",
  handover: "documents",
};

export const OPTIONAL_STAGES = [];

export const projectTab = (pid, tab) =>
  pid ? `/projects/${pid}${tab && tab !== "overview" ? `?tab=${tab}` : ""}` : "/projects";
